<template>
  <div class="-info">
    <div class="c_main -pad-btm">
      <div class="inner">
        <nav class="c_pnkz">
          <ul class="c_pnkz_list">
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Home' })">
                ホーム
              </a>
            </li>
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Info' })">
                JC3からのお知らせ
              </a>
            </li>
            <li>{{ info.title }}</li>
          </ul>
        </nav>
        <section class="info">
          <p class="info_ttl">JC3からのお知らせ</p>
          <article class="single">
            <header class="single_hd">
              <div class="single_hd_info">
                <time>{{ info.start_datetime | formatDateDot }}</time>
              </div>
              <h1 class="single_hd_ttl">{{ info.title }}</h1>
            </header>
            <div class="single_body">
              <p
                style="white-space:pre-wrap; word-wrap:break-word;"
                class="infotxt"
                v-html="linkedText"
              ></p>
            </div>
            <div class="single_ft">
              <a class="c_btn" @click="$router.push({ name: 'Info' })">
                一覧に戻る
              </a>
            </div>
          </article>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      info: {
        title: "",
        start_datetime: "",
        content: ""
      }
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    linkedText() {
      // 正規表現でURLを検出し、<a>タグで置換
      return this.info.content.replace(
        /(https?:\/\/[^\s<>()]+)/g,
        '<a href="$1" target="_blank" rel="noopener noreferrer" class="infolink">$1</a>'
      );
    }
  },
  methods: {
    fetch() {
      this.loading = true;

      this.$authAxios
        .get(`/api/info/${this.id}`)
        .then(response => {
          this.info = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
@import "~@/css/info.css";

.infotxt >>> .infolink {
  appearance: none;
  color: #78ba00;
  text-decoration: underline;
  border: none;
  padding: 0;
  margin: 0;
  font-style: normal;
  font-size: inherit;
  cursor: pointer;
  background: none;
}

.infotxt >>> .infolink:hover {
  text-decoration: none;
}
</style>
